import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';
import { SaleListDetailSeriesItem } from './item/SaleListDetailSeriesItem';


export function SaleListDetailSeries(props: any) {

  const available = props.available;
  const dispIndex = props.dispIndex;
  const setDispIndex = props.setDispIndex;
  const saleImageList = props.saleImageList;
  const movieTitleList = props.movieTitleList;
  const movieTimeList = props.movieTimeList;

  const isPc = useContext(cmnContext).isPc;
  const grayColor = useContext(SaleListContext).grayColor;


  return (
    <div style={{
      width: isPc? '90%' : '95%',
      backgroundColor: grayColor,
      margin: '30px auto',
      padding: isPc? '3%' : '2%',
      borderRadius: '10px',
    }}>

      <p style={{
        fontSize: isPc? '130%' : '110%',
        fontWeight: 'bold',
        margin: available? '0px' : '10px 0px',
      }}>【動画セット】</p>

      {available &&
        <p style={{
          fontSize: isPc? '100%' : '80%',
        }}>タップで再生できます</p>
      }

      {movieTitleList.map((movieTitle: string, index: number) => {
        return (
          <SaleListDetailSeriesItem
            available={available}
            dispIndex={dispIndex}
            setDispIndex={setDispIndex}
            index={index}
            saleImage={saleImageList[index]}
            movieTitle={movieTitle}
            movieTimeList={movieTimeList}
          />
        );
      })}

    </div>
  );
}